import Footer from 'components/Footer'
import HeaderLarge from 'components/HeaderLarge'
import Information from 'components/Information'
import * as React from 'react'

const SceneComponent: React.FC = () => {
  return (
    <>
      <HeaderLarge title="確認メール送信済み" />
      <Information>
        <p>
          ご登録のメールアドレスに確認メールを送信しました。
          <br />
          メール内のリンクをクリックして登録を完了してください。
          <br />
          メールが届かない場合は迷惑メールフォルダもご確認ください。
        </p>
      </Information>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
